import { useState, useEffect } from "react";
import { Frame, Loading, Header, ValidaUid } from "../components";
import { db } from "../config/firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";

const Contato = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const buscaDados = async () => {
      const uid = await ValidaUid();

      if (uid) {
        const qry = await getDoc(doc(db, "ebserh2026", uid));

        const data = qry.data();

        if (data?.anoAtual === "2025") setDados(data);

        setLoading(false);
      } else {
        navigate("/login");
      }
    };

    buscaDados();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      <Frame
        body={
          <div className="justify">
            <p>Whatsapp Fretamento: (53) 98122-2534</p>
            <p>Telefone: (53) 3278-7000 ramal 233 ou 248</p>
            <p>De segunda à sexta, das 07:30 às 12:00 e das 13:30 às 17:30</p>
          </div>
        }
        title="Fale Conosco"
      />
    </>
  );
};

export default Contato;
